import { get } from 'lodash';

import {
  CLEAR_POSTCODE_BANNER,
  FETCH_POSTCODE_BANNER_REQUEST,
  FETCH_POSTCODE_BANNER_SUCCESS,
  FETCH_POSTCODE_BANNER_ERROR,
  TOGGLE_POSTCODE_BANNER_VISIBILITY,
} from '../actions/postcodeBanner';

export const initialState = {
  isFetching: false,
  isReceived: false,
  isHidden: false,
};

export default function postcodeBanner(state = initialState, action) {
  switch (action.type) {
    case FETCH_POSTCODE_BANNER_REQUEST:
      return {
        ...state,
        isFetching: true,
      };
    case FETCH_POSTCODE_BANNER_SUCCESS:
      // 'data' may be undefined or be an empty string - properly handle 204 responses
      return {
        ...state,
        bannerId: get(action.data, 'docNo'),
        bannerVersion: get(action.data, 'docVersionNo'),
        html: get(action.data, 'freeHtml.html'),
        isFetching: false,
        isReceived: true,
      };
    case FETCH_POSTCODE_BANNER_ERROR:
      return {
        ...state,
        isFetching: false,
      };
    case CLEAR_POSTCODE_BANNER:
      return {
        ...initialState,
      };
    case TOGGLE_POSTCODE_BANNER_VISIBILITY:
      return {
        ...state,
        isHidden: action.isHidden,
      };
    default:
      return state;
  }
}
